import { Directive, ElementRef, Renderer2, OnInit, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appHighlightClick]'
})
export class HighlightClickDirective implements OnInit {
  
  @Output() influencerProfileClick = new EventEmitter<void>();
  @Output() influencerDeliverablesClick = new EventEmitter<void>();
  @Output() influencerProgramDeliverablesClick = new EventEmitter<void>();
  @Output() termsAndConditionsClick = new EventEmitter<void>();

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.setupHighlighting();
  }

  private setupHighlighting(): void {
    const influencerSpans = this.el.nativeElement.querySelectorAll('.influencer_profile');
    influencerSpans.forEach((span: HTMLElement) => {
      // this.renderer.setStyle(span, 'color', '#981f41');  
      this.renderer.setStyle(span, 'font-weight', '600');
      this.renderer.setStyle(span, 'cursor', 'pointer');
      this.renderer.setStyle(span, 'text-decoration', 'underline');
      this.renderer.listen(span, 'click', () => {
        this.influencerProfileClick.emit();
      });
    });

    const deliverablesSpans = this.el.nativeElement.querySelectorAll('.influencer_program_deliverables');
    deliverablesSpans.forEach((span: HTMLElement) => {
      // this.renderer.setStyle(span, 'color', '#981f41');
      this.renderer.setStyle(span, 'font-weight', '600');
      this.renderer.setStyle(span, 'cursor', 'pointer');
      this.renderer.setStyle(span, 'text-decoration', 'underline');
      this.renderer.listen(span, 'click', () => {
        this.influencerDeliverablesClick.emit();
      });
    });

    const influencerDeliverablesItems = this.el.nativeElement.querySelectorAll('.influencer_deliverables');
    influencerDeliverablesItems.forEach((span: HTMLElement) => {
      // this.renderer.setStyle(span, 'color', '#981f41');
      this.renderer.setStyle(span, 'font-weight', '600');
      this.renderer.setStyle(span, 'cursor', 'pointer');
      this.renderer.setStyle(span, 'text-decoration', 'underline');
      this.renderer.listen(span, 'click', () => {
        this.influencerProgramDeliverablesClick.emit();
      });
    });

    const termsAndConditionsSpan = this.el.nativeElement.querySelectorAll('.terms_and_conditions');
    termsAndConditionsSpan.forEach((span: HTMLElement) => {
      // this.renderer.setStyle(span, 'color', '#981f41');
      this.renderer.setStyle(span, 'font-weight', '600');
      this.renderer.setStyle(span, 'cursor', 'pointer');
      this.renderer.setStyle(span, 'text-decoration', 'underline');
      this.renderer.listen(span, 'click', () => {
        this.termsAndConditionsClick.emit();
      });
    });
  }
}
